import { UserType } from "@/common/types";
import DoctorsView from "./components/doctorsView";
import PatientsView from "./components/patientView";
import { capitalize } from "@/utils/common.util";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import MedicalHistory from "./components/medicalHistory";
import { ScrollArea } from "@/components/ui/scroll-area";

interface DetailsProps {
  selectedUser: UserType;
}

const renderUserDetails = (user: UserType) => {
  return (
    <div>
      <div className="text-3xl font-bold">{user.name}</div>
      <div className="text-gray-400 text-xs">{user.email}</div>
      <div className="text-gray-400 text-xs">({capitalize(user.role)})</div>
    </div>
  );
};

const Details = ({ selectedUser }: DetailsProps) => {
  const renderContent = () => {
    switch (selectedUser.role) {
      case "doctor":
        return <DoctorsView user={selectedUser} />;
      case "patient":
        return <PatientsView user={selectedUser} />;
      default:
        return renderUserDetails(selectedUser);
    }
  };

  return (
    <ScrollArea className="h-[calc(100vh-180px)] overflow-auto">
      <div className="px-2 md:px-8">
        <div>{renderContent()}</div>
        {selectedUser.role === "patient" && (
          <div className="mt-4">
            <Accordion
              type="single"
              collapsible
              defaultValue={"medicalHistory"}
              className="w-full"
            >
              <AccordionItem value="medicalHistory">
                <AccordionTrigger className="font-bold">
                  Medical History
                </AccordionTrigger>
                <AccordionContent>
                  <MedicalHistory patientId={selectedUser.id as number} />
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        )}
      </div>
    </ScrollArea>
  );
};

export default Details;
